import { useEffect } from "react";
import { useProctorHomeQuery } from "./homeApiSlice";
import Stats from "./Stats";
import RecentActivity from "./recentActivity/RecentActivity";
import ShortcutMenu from "./ShortcutMenu";

interface TeacherHomeProps {
	setAlerts: (alerts: Record<number, string> | undefined) => void;
}

export default function TeacherHome(props: TeacherHomeProps) {
	const result = useProctorHomeQuery();
	const data = result.data;

	useEffect(() => {
		props.setAlerts(data?.alerts);
	}, [data]);

	return (
		<div>
			<Stats
				label="Student Usage"
				courseCreateDate={data?.courseCreateDate}
				loading={result.isLoading}
				stats={data?.allStats ?? []}
			/>
			<div className="mt-4 flex py-2 flex-col sm:flex-row">
				<RecentActivity
					label="Course Activity"
					loading={result.isLoading}
					teacherData={data}
				/>
				<div className="px-4 lg:px-8 w-full sm:w-1/3 md:w-1/4">
					<ShortcutMenu />
				</div>
			</div>
		</div>
	);
}
